import { CalendarCheck } from "@phosphor-icons/react";
import type { FeaturePalette } from "@/shared/components/command-palette/types";

export const batteryPalette: FeaturePalette = {
  commands: [
    {
      id: "battery.start",
      title: "Start monthly check-in",
      icon: CalendarCheck,
      scopeId: "battery",
      keywords: ["battery", "check-in", "transfer", "matrix", "span", "reaction", "baseline"],
      run: (ctx) => ctx.router.push("/battery"),
    },
  ],
};
